<template>
  <div class="container">
    <h3>{{ dataType.cname }}</h3>
    <div v-for="a in dataType.attr" :key="a.jname" class="form-group">
      <label>{{ a.fname }}</label>
      <DateTimePicker v-if="!data[a.jname + '_parsed'] && a.type=='java.util.Date'" :value="data[a.jname]" @update="(e) => { updateDateTime(a.jname,e); }"/>
      <input v-else :placeholder="a.type" type="text" v-model="data[a.jname]" class="form-control"/>
      <div class="form-check">
        <input :id="a.jname" type="checkbox" v-model="data[a.jname + '_parsed']" class="form-check-input"/>
        <label :for="a.jname">parsed</label>
      </div>
    </div>
  </div>
</template>

<script>
import DateTimePicker from '@/components/DateTimePicker.vue'

export default {
  props: ["dataType","data"],
  components: {
    DateTimePicker
  },
  mounted() {
    console.log('edit data type',this.dataType);
  },
  methods: {
    updateDateTime(key,value) {
      console.log('up time',key,value);
      this.data[key] = value;
    }
  }
}
</script>
